class SuccessController {

}

export default SuccessController;



// WEBPACK FOOTER //
// ./client/app/pages/customer/deposit/component/ecopayz/success.controller.js